import React, { useState } from "react";

/**
 * Small, dismissible diagnostic panel shown ONLY when an auth attempt fails.
 * Displays NON-SENSITIVE runtime info + a copy button so the user can share
 * an actionable trace with support without disclosing passwords or tokens.
 */
export function AuthDiagPanel({ diagId, env, error, probe }) {
  const [copied, setCopied] = useState(false);
  const payload = { diagId, env, error, probe };
  const text = JSON.stringify(payload, null, 2);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (_) {
      const ta = document.createElement("textarea");
      ta.value = text; document.body.appendChild(ta); ta.select();
      try { document.execCommand("copy"); setCopied(true); } catch (_) {}
      document.body.removeChild(ta);
    }
  };

  return (
    <details
      data-testid="auth-diag-panel"
      className="mt-3 rounded-md border border-amber-300 bg-amber-50 dark:bg-amber-950/30 dark:border-amber-800 p-3 text-xs text-amber-950 dark:text-amber-100"
      open
    >
      <summary className="cursor-pointer font-mono font-semibold select-all" data-testid="auth-diag-id">
        {diagId}
      </summary>
      <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1 font-mono">
        <div><span className="opacity-70">API:</span> {env?.apiBase}</div>
        <div><span className="opacity-70">bundle:</span> {env?.bundle}</div>
        <div><span className="opacity-70">online:</span> {String(env?.online)}</div>
        <div><span className="opacity-70">SW ctrl:</span> {env?.sw?.controller ? env.sw.scriptURL : "none"}</div>
        <div><span className="opacity-70">status:</span> {error?.hasResponse ? error.status : "no-response"}</div>
        <div><span className="opacity-70">backendCode:</span> {error?.backendCode || "-"}</div>
        <div><span className="opacity-70">axiosCode:</span> {error?.code || "-"}</div>
        <div><span className="opacity-70">probe /diag/echo:</span> {probe?.ok ? `${probe.status} in ${probe.ms}ms` : (probe?.error?.status || "unreachable")}</div>
      </div>
      <div className="mt-2 flex gap-2">
        <button
          type="button"
          onClick={copy}
          data-testid="auth-diag-copy"
          className="px-2 py-1 rounded bg-amber-200 hover:bg-amber-300 dark:bg-amber-800 dark:hover:bg-amber-700 text-xs"
        >
          {copied ? "✓ Copié" : "Copier le diagnostic"}
        </button>
        <span className="opacity-60 self-center">Aucun mot de passe ni cookie n'est collecté.</span>
      </div>
    </details>
  );
}
